import HelpOutline from '@mui/icons-material/HelpOutline';
import { Box, IconButton, Popover, Typography } from '@mui/material';
import { useState } from 'react';
import SERINUMBERIMG from '~/assets/images/serieNumber.png';
import { radius } from '~/styles/tokens/shape';

type ContractSerialNumberHelpProps = {
  appId?: string;
};

export default function ContractSerialNumberHelp({
  appId = 'journey-contract-step2-serial-help'
}: ContractSerialNumberHelpProps) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  return (
    <>
      <IconButton
        aria-label="Ajuda sobre número de série"
        data-app-id={appId}
        data-testid="contract-serial-help"
        onClick={(event) => setAnchorEl(event.currentTarget)}
        size="small"
        sx={{ color: 'primary.main' }}
      >
        <HelpOutline fontSize="small" />
      </IconButton>
      <Popover
        anchorEl={anchorEl}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        onClose={() => setAnchorEl(null)}
        open={Boolean(anchorEl)}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        slotProps={{
          paper: {
            sx: {
              bgcolor: 'grey.900',
              borderRadius: `${radius.large}px`,
              boxShadow: 4,
              color: 'primary.contrastText',
              maxWidth: 360,
              p: 2
            }
          }
        }}
      >
        <Typography fontWeight={700} sx={{ mb: 1 }} variant="caption">
          Na bicicleta
        </Typography>
        <Typography sx={{ mb: 1.5 }} variant="body2">
          O número de série pode ser encontrado na sua bike em um dos seguintes locais:
        </Typography>
        <Box
          component="img"
          src={SERINUMBERIMG}
          alt="Locais do número de série na bicicleta"
          sx={{ display: 'block', maxWidth: '100%' }}
        />
      </Popover>
    </>
  );
}
